import dayjs from "utils/dates/dayjsex";

export const PRESALE_DATE = dayjs.tz("2022-01-24 19:00", "America/Los_Angeles");
export const PUBLIC_DATE = dayjs.tz("2022-01-25 19:00", "America/Los_Angeles");
